// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const DealerHierarchyFacet = t.struct({
    dealers: t.list(t.String, 'Dealers'),
    selectedAccounts: t.Object,
    selectedCities: t.Object,
    selectedLeadAccounts: t.Object,
    selectedTerritories: t.Object
}, 'DealerHierarchyFacet');

export const getDefaultState = () =>
    new DealerHierarchyFacet({
        dealers: [],
        selectedAccounts: {},
        selectedCities: {},
        selectedLeadAccounts: {},
        selectedTerritories: {}
    });

export default DealerHierarchyFacet;



// WEBPACK FOOTER //
// ./src/tcsm/shared/state/dealer-hierarchy-facet.js